module.exports = __webpack_public_path__ + "media/images/about/ac_5-c930d14a3e16950f423236cb7bb0d304.jpg";